import * as React from 'react';
import { INodeInfo } from '../..';
import {
  Checked,
  General,
  Map,
  Control, UserRounded,
  CheckedFill,
  Circle
} from '../../../../../components/Icons';
import Info from './info';

interface IParamProps {
  selectedNode: INodeInfo;
}

const Param: React.FunctionComponent<IParamProps> = ({ selectedNode }) => {
  const getStatusIcon = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'active':
      case 'online':
        return <CheckedFill className="w-5 h-5 text-green-500" />;
      case 'inactive':
      case 'offline':
        return <Circle className="w-5 h-5 text-red-500" />;
      default:
        return <Circle className="w-5 h-5 text-yellow-500" />;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'active':
      case 'online':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'inactive':
      case 'offline':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <div className="space-y-6">

        {/* Basic Information */}
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-gray-900 flex items-center space-x-2">
            <General className="w-5 h-5 text-gray-600" />
            <span>Basic Information</span>
          </h3>
          
          <div className="grid-cols-1 md:grid-cols-2 gap-4 flex flex-wrap">
            <Info Icon={<General className="w-4 h-4 text-gray-500" />} label="Product ID" value={selectedNode.nodes.productId} />
            <Info Icon={<General className="w-4 h-4 text-gray-500" />} label="Serial Number" value={selectedNode.nodes.serialNumber} />
            <Info Icon={<Checked className="w-4 h-4 text-gray-500" />} label="Status" value={selectedNode.nodes.status.toString()} />
            <Info Icon={<Control className="w-4 h-4 text-gray-500" />} label="Slot ID" value={selectedNode.nodes.slotId?.toString() || 'N/A'} />
            <Info Icon={<UserRounded className="w-4 h-4 text-gray-500" />} label="Group ID" value={selectedNode.nodes.groupId?.toString() || 'N/A'} />
          </div>
        </div>

        {/* Node Parameters */}
        {selectedNode.nodeParams && (
          <div className="space-y-4 pt-4 border-t border-gray-200">
            <h3 className="text-lg font-medium text-gray-900 flex items-center space-x-2">
              <Map className="w-5 h-5 text-gray-600" />
              <span>Location Parameters</span>
            </h3>
            
            <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
              <div className="flex items-center space-x-2 mb-2">
                <Map className="w-4 h-4 text-blue-600" />
                <label className="text-sm font-medium text-blue-800">Coordinates</label>
              </div>
              <p className="text-sm font-mono text-blue-900 bg-white px-3 py-2 rounded border border-blue-200">
                {selectedNode.nodeParams.location?.coordinates
                  ? (selectedNode.nodeParams.location.coordinates[1].toString() + ', ' + selectedNode.nodeParams.location.coordinates[0].toString())
                  : (
                    <span className="text-gray-400 italic">Location not available</span>
                  )
                }
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Param;
